var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Hero',{attrs:{"title":("" + (_vm.$t('message.hero.helpUsVerify', { name: _vm.firstName })))}}),_c('EmphasizeBox',{staticClass:"mt-3 mb-4",attrs:{"text":("" + (_vm.$t('message.credit.disclaimer.noAffectScoreVersion2')))}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }